import { FC } from 'react';

import { useFormStepperDialogContext } from 'src/contexts/FormStepperDialogContext';
import { SharedApiFormContextProvider } from 'src/contexts/shared/SharedApiFormContext';
import { SharedDataFormContextProvider } from 'src/contexts/shared/SharedDataFormContext';
import { useSharedDataContext } from 'src/contexts/SharedDataContext';
import blancoSwedenFormDefaultData from 'src/defaults/BlancoSweden/BlancoSwedenFormDefaultData';

import BlancoSwedenFormStepperDialog from './BlancoSwedenFormStepperDialog';
import BlancoSharedAppCreatedSection from '../BlancoShared/sections/BlancoSharedAppCreatedSection';
import BlancoSharedStartPageSection from '../BlancoShared/sections/BlancoSharedStartPageSection';

interface BlancoSwedenStartPageProps { }

const BlancoSwedenStartPage: FC<BlancoSwedenStartPageProps> = (props) => {
  const { } = props;

  const { formData } = useSharedDataContext();
  const { appIsCreated } = useFormStepperDialogContext();

  return (
    <SharedApiFormContextProvider>
      <SharedDataFormContextProvider defaultData={blancoSwedenFormDefaultData}>
        {formData && (
          <>
            {!appIsCreated && (
              <BlancoSharedStartPageSection />
            )}
            {appIsCreated && (
              <BlancoSharedAppCreatedSection />
            )}
            <BlancoSwedenFormStepperDialog />
          </>
        )}

      </SharedDataFormContextProvider>
    </SharedApiFormContextProvider>
  );
};


export default BlancoSwedenStartPage;
